"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebug = useDebug;
var _react = require("react");
/* eslint-disable no-console -- it is the point of this helper */

function getTime() {
  const date = new Date();
  const minutes = `0${date.getMinutes()}`;
  const seconds = `0${date.getSeconds()}`;
  const milliseconds = `00${date.getMilliseconds()}`;
  const LAST_TWO_DIGITS = -2;
  const LAST_THREE_DIGITS = -3;
  return `${date.getHours()}:${minutes.slice(LAST_TWO_DIGITS)}:${seconds.slice(LAST_TWO_DIGITS)}.${milliseconds.slice(LAST_THREE_DIGITS)}`;
}
function isDebugEnabled() {
  try {
    const serializedData = localStorage.getItem('ori-ui-quantity-picker-debug');
    if (serializedData) {
      const value = JSON.parse(serializedData);
      return value === 4;
    }
    return false;
  } catch (error) {
    return false;
  }
}
function useDebug(key) {
  const isEnabled = isDebugEnabled();
  const log = (0, _react.useCallback)((...args) => {
    if (!isEnabled) {
      return;
    }
    console.log(`%c🔶 ${getTime()} ${key}`, 'color:#FFA07A;background:#1c1c1c;', ...args);
  }, [isEnabled, key]);
  return {
    log
  };
}
//# sourceMappingURL=useDebug.js.map